import { MatchesList, SubmitButton } from "../";
import Countdown from "../Countdown/Countdown";

/**
 * Component for displaying the current gameweek with prediction functionality
 * @param {Object} props - Component props
 * @param {Array} props.filteredMatches - Matches for the current gameweek
 * @param {Array} props.availableMarkets - Available markets for predictions
 * @param {Array} props.summary - Match summaries
 * @param {Array} props.userPredictions - User's existing predictions
 * @param {Object} props.currentScores - Current scores for matches
 * @param {Function} props.onScoreChange - Handler for score changes
 * @param {Object} props.fansUnitedSDK - FansUnited SDK instance
 * @param {boolean} props.canMakePredictions - Whether predictions can still be made
 * @param {Object} props.timeleft - Time left until deadline
 * @param {string} props.deadline - Deadline string
 * @param {boolean} props.isButtonActive - Whether submit button is active
 * @param {boolean} props.isSubmitting - Whether submission is in progress
 * @param {boolean} props.hasSubmitted - Whether user has submitted predictions
 * @param {boolean} props.hasChangedSinceSubmission - Whether predictions have been changed since last submission
 * @param {Function} props.onSubmit - Submit handler
 * @returns {JSX.Element} - Current gameweek component
 */
const CurrentGameweek = ({
	filteredMatches,
	availableMarkets,
	summary,
	userPredictions,
	currentScores,
	onScoreChange,
	fansUnitedSDK,
	canMakePredictions,
	timeleft,
	deadline,
	isButtonActive,
	isSubmitting,
	hasSubmitted,
	hasChangedSinceSubmission,
	onSubmit,
}) => {
	return (
		<>
			{filteredMatches.length > 0 ? (
				<>
					<Countdown initialTimeLeft={timeleft} deadline={deadline} />

					<MatchesList
						matches={filteredMatches}
						availableMarkets={availableMarkets}
						summary={summary}
						userPredictions={userPredictions}
						currentScores={currentScores}
						onScoreSet={onScoreChange}
						fansUnitedSDK={fansUnitedSDK}
						canMakePredictions={canMakePredictions}
					/>

					<SubmitButton
						isButtonActive={isButtonActive}
						isSubmitting={isSubmitting}
						hasSubmitted={hasSubmitted}
						hasChangedSinceSubmission={hasChangedSinceSubmission}
						onSubmit={onSubmit}
						matchesCount={filteredMatches.length}
					/>
				</>
			) : (
				<Countdown
					initialTimeLeft={{ days: 0, hours: 0, minutes: 0, seconds: 0 }}
					deadline={deadline}
					showDeadlineMissed={true}
					deadlineMissedTitle="Matchweek Deadline"
					deadlineMissedMessage="You didn't make your predictions for this week, so no points were earned - but there's always next week to bounce back!"
				/>
			)}
		</>
	);
};

export default CurrentGameweek;
